// extracted by mini-css-extract-plugin
export default {"brpLogo":"brpLogo_brpLogo__8tReG"};